import {gql} from "@apollo/client";

export const VALIDATE_GRAPHQL_QUERY = gql`
	mutation ValidateGraphQl ($graphQl: String!, $take: Int!, $anvaSyncStage: String, $anvaSyncAccount: String) {
		validateGraphQl(input: {graphQl: $graphQl, take: $take, anvaSyncStage: $anvaSyncStage, anvaSyncAccount: $anvaSyncAccount}) {

			validateGraphQl {
				success
				result
			}
			errors {
				... on ArgumentError {
					message
				}
			}
		}
	}
`;
